import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import Srcset from "@/components/common/Srcset";
import TestimonialSlide from "@/components/common/Testimonial/TestimonialSlide";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { selectSliderElementsGen } from "@/helpers/generalHelper";
import { useIntersection } from "../../common/UseIntersection";
import { reportError } from "@/helpers/errorHelper";

function NextArrow(props) {
    const { className, onClick, refCallBack  } = props;
    return (
      <div className={className} onClick={onClick} tabIndex={0} ref={refCallBack}>
        <Srcset
          requirePath={true}
          svgFile={true}
          src={"images/Icons/Chevron/large.svg"}
          alt="Arrow Button"
          height="12"
          width="12"
        />
      </div>
    );
  }
  
  function PrevArrow(props) {
    const { className, onClick, refCallBack } = props;
    return (
      <div className={className} onClick={onClick} tabIndex={0} ref={refCallBack}>
        <Srcset
          requirePath={true}
          svgFile={true}
          src={"images/Icons/Chevron/large.svg"}
          alt="Arrow Button"
          height="12"
          width="12"
        />
      </div>
    );
  }

function Testimonial({Testimonial, props}) {
  let count = 1
  let stateInitial = {
    activeSlide: count,
  };
  const [state, setState] = useState(stateInitial);
  const isTablet = useMediaQuery("(max-width: 1024px)");

  const nextArrowRef = useRef(null);
  const prevArrowRef = useRef(null);

  const handleArrowFocus = () => {
    const navbarHeight = 60;
    const focusedElement = document.activeElement;

    if(focusedElement === nextArrowRef?.current ){
      if(!inViewportNext || (nextArrowRef.current.getBoundingClientRect().top < navbarHeight)){
        focusedElement.scrollIntoView({behavior: "smooth", block: "center"});
      }
    }
    if (focusedElement === prevArrowRef?.current){
      if(!inViewportPrev || (prevArrowRef.current.getBoundingClientRect().top < navbarHeight)){
        focusedElement.scrollIntoView({behavior: "smooth", block: "center"});
      }
    }
  }

  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    lazyLoad: true,
    draggable: false,
    afterChange: (activeSlide) => setState({ activeSlide: activeSlide + 1 }),
    nextArrow: !isTablet && <NextArrow refCallBack={nextArrowRef}/>,
    prevArrow: !isTablet && <PrevArrow refCallBack={prevArrowRef}/>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
        }
      }
    ],
  }; 

  const sliderRef= useRef(null); 
  const inViewportNext = useIntersection(nextArrowRef, "0px");
  const inViewportPrev = useIntersection(prevArrowRef, "0px");
  const [tabPressed, setTabPressed] = useState(false);
  const isMobileDevice = useMediaQuery("(max-width: 767px)");
  useEffect(()=>{
    if (isMobileDevice) return; 
    const handleKeyDown = (event) =>{
      try {
        if(event?.key === "Tab" &&!tabPressed){
          setTabPressed(true);
          selectSliderElementsGen(sliderRef,true);
        }
      } catch (error) {
        reportError("tab indexing testimonial carousel & not tab pressed");
        reportError(error) // Log error using reportError function
      }
    };
    handleArrowFocus();
    const handleKeyUp = (event) =>{
      try {
        if(event?.key === "Tab" ){
          setTabPressed(false);
        }
      } catch (error) {
        reportError("tab indexing testimonial carousel");
        reportError(error) // Log error using reportError function
      }
    };

    window.addEventListener("keydown",handleKeyDown);
    window.addEventListener("keyup",handleKeyUp);

    return ()=>{
      window.removeEventListener("keydown",handleKeyDown);
      window.removeEventListener("keyup",handleKeyUp);
    }
  },[sliderRef,tabPressed, isMobileDevice]);

  let totalCount = 0
  let testimonials = null;
  if(typeof Testimonial != 'undefined'){
    totalCount = Testimonial.length;
    testimonials = Testimonial.map((eachTestimonial, index) => {
        return <TestimonialSlide key={index} {...eachTestimonial} totalCount={totalCount} activeSlide={state.activeSlide}/>
    });
  } 
  return (
    <>
      <div className={`testimonial-section`}>
        {totalCount > 1 && (
          <div className="small slider-counter italic">
            <span className="active-slide">{state.activeSlide}</span>
            <span className="slash">/</span>
            <span className="total-slide">{totalCount}</span>
          </div>
        )}
        {typeof testimonials != "undefined" &&
        typeof testimonials != "string" &&
        testimonials &&
        testimonials.length > 0 ? (
          <Slider ref={sliderRef} {...settings}>{testimonials}</Slider>
        ) : (
          "Enter Testimonial here"
        )}
      </div>
    </>
  );
}

export default Testimonial;
